const awsConfig = {
  Auth: {
    region: 'us-west-1',
    userPoolId: 'us-west-1_d0LA3tosn',
    userPoolWebClientId: '2l2se4ifi35fm793u8v7gcm3in',
    oauth: {
      domain: 'wedarchive-admin-auth.auth.us-west-1.amazoncognito.com',
      scope: ['openid', 'email', 'profile'],
      redirectSignIn: 'https://admin.wedarchive.com',
      redirectSignOut: 'https://admin.wedarchive.com',
      responseType: 'code'
    }
  }
};
export default awsConfig;
